export default __webpack_public_path__ + "static/bunker-pages-2-mobile-14d6138b552602c8cfbf1c265b2f007a.jpg";